import register from 'ShopUiBundle/modules/app/registry';

import './style.scss';

// tslint:disable-next-line
register('catalog-breadcrumb', () => import(/* webpackMode: "lazy" */'./catalog-breadcrumb'));
